import request from '@/utils/request'
// 获取供应商首页数据
export function homeData (params) {
  return request({
    url: '/mchtHome/data',
    method: 'get',
    params
  })
}
//修改交易开关
export function updateTradeFlag (data) {
  return request({
    url: '/mchtHome/trade/flag',
    method: 'put',
    data
  })
}
//是否开通支付
export function istradeflag (params) {
  return request({
    url: '/mchtHome/istradeflag',
    method: 'get',
    params
  })
}
//获取当前登录供应商资料信息
export function getAuditInfo () {
  return request({
    url: '/mch/data/getPmsMchtAptitude',
    method: 'get'
  })
}
//获取最新审核日志
export function getAuditLog () {
  return request({
    url: '/mch/data/getAuditLog',
    method: 'get'
  })
}

// 获取供应商首页统计列表
export function getStatisticsList (params) {
  return request({
    url: '/mchtHome/getStatisticsList',
    method: 'get',
    params
  })
}
// 获取供应商首页统计数据
export function getSupplierHomeData (params) {
  return request({
    url: '/mchtHome/getSupplierHomeData',
    method: 'get',
    params
  })
}
// 获取店铺商品销量排行
export function homeGoodsList (params) {
  return request({
    url: '/mchtHome/sort',
    method: 'get',
    params
  })
}
// 获取文章列表
export function articleList (params) {
  return request({
    url: '/article/list',
    method: 'get',
    params
  })
}
// 根据id获取文章详情
export function articleDetail (params) {
  return request({
    url: '/article/detail',
    method: 'get',
    params
  })
}
// 根据广告位置获取广告信息
export function getBannerList (params) {
  return request({
    url: '/ad/getByPosition',
    method: 'get',
    params: params
  })
}
// 根据mchtId查询一条商家数据
export function getOneByMchtId (params) {
  return request({
    url: '/pmsMchtShopInfo/getOneByMchtId',
    method: 'get',
    params: params
  })
}
// 判断当前保证金状态 账户状态 status: 1正常 2欠费
export function checkBondStatus (params) {
  return request({
    url: '/pmsMchtShopInfo/checkBondStatus',
    method: 'get',
    params: params
  })
}
// 获取导航栏数据
export function getNavData (params) {
  return request({
    url: '/mchtHome/getNavigationBarInfo',
    method: 'get',
    params
  })
}

// 获取强制推送消息
export function getPushMessage (params) {
  return request({
    url: '/mchtHome/pushMessage',
    method: 'get',
    params
  })
}

export function wechatNoticeLogin(params) { // 微信消息通知推送绑定
  return request({
    url: '/mchtHome/pushAuthUrl',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js